export const EMPTY_ENTRY_MARK = '-';

/**
 * Backend listings reject `pagination.take` above 100, so an `id IN` request — which needs a row per
 * id — can carry at most this many ids.
 */
export const MAX_IDS_PER_REQUEST = 100;

export const DEFAULT_LOCALE = 'pl-PL';
export const DEFAULT_TIMEZONE = 'Europe/Warsaw';
